import { ProductType, TenantProduct } from 'src/types/Tenant';

import { Logger } from '../Logger';
import { API_URL_PATHS } from '../server/ApiUrlPaths';
import { apiCall } from '../server/ServerApi';

const { CENTRAL_CONFIG_PATH } = API_URL_PATHS;
export type TConfiguration = Record<string, Record<string, unknown>>;

// product hub config lives under the platform product
const getPLatformProductID = (products: TenantProduct[]): string => {
	if (!products) {
		return null;
	}
	return products.find((product: TenantProduct) => product.type === ProductType.PLATFORM)?.id;
};

export const getCentralConfig = async (products: TenantProduct[]): Promise<TConfiguration> => {
	const platformProductID = getPLatformProductID(products);
	if (platformProductID) {
		try {
			// Fetch both configurations in parallel for better performance
			const [productHubConfigResult, platformConfigResult] = await Promise.all([
				apiCall(
					'GET',
					`${CENTRAL_CONFIG_PATH}?productId=${platformProductID}&subPath=PRODUCT_HUB_UI`,
					{ isConfigUrl: true }
				) as Promise<{ PRODUCT_HUB_UI?: TConfiguration }>,
				apiCall(
					'GET',
					`${CENTRAL_CONFIG_PATH}?productId=${platformProductID}&subPath=PLATFORM/DEV_TOGGLES`,
					{ isConfigUrl: true }
				) as Promise<{ PLATFORM?: { DEV_TOGGLES?: TConfiguration } }>
			]);

			const productHubConfig = (productHubConfigResult?.PRODUCT_HUB_UI || {}) as TConfiguration;
			const platformConfig = (platformConfigResult?.PLATFORM?.DEV_TOGGLES || {}) as TConfiguration;
			return {
				...productHubConfig,
				...platformConfig
			} as TConfiguration;
		} catch (error: unknown) {
			Logger.error('Error fetching central configuration', error);
			return null;
		}
	}
	return null;
};
